import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'grupos'
})
export class GruposPipe implements PipeTransform {
  transform(value: any): any {
    if (value) {
      return 'Inclusão';
    } else {
      return 'Pré-Inclusão';
    }
  }
}
